import { useEffect, useState } from "react";
import { flushSync } from "react-dom";
import Slider from "@mui/material/Slider";
import { styled } from "@mui/material/styles";
import { SizingTypeValue } from "../../../types/enums";

const CustomSlider = styled(Slider)({
  color: "#DBE2FF",
  height: 8,
  "& .MuiSlider-track": {
    border: "none",
  },
  "& .MuiSlider-thumb": {
    height: 24,
    width: 24,
    backgroundColor: "#40B4B4",
    border: "2px solid #40B4B4",
    "&:focus, &:hover, &.Mui-active, &.Mui-focusVisible": {
      boxShadow: "inherit",
    },
    "&::before": {
      display: "none",
    },
  },
  "& .MuiSlider-valueLabel": {
    lineHeight: 1.2,
    fontSize: 12,
    background: "unset",
    padding: 0,
    width: 80,
    height: 32,
    borderRadius: "5px",
    backgroundColor: "#40B4B4",
    transformOrigin: "bottom left",
    "&::before": { display: "none" },
  },
  "& .MuiSlider-mark": {
    height: 6, // Adjust the height of the data points
    width: 6, // Adjust the width of the data points
    borderRadius: "50%", // Make it circular
    backgroundColor: "#40B4B4", // Customize color
  },
  // "& .MuiSlider-markLabel": {
  //   fontSize: "12px", // Adjust font size for labels
  //   color: "#3C3C3C", // Customize label color
  // },
});

export function SliderComponent(props: any) {
  const {
    data,
    field,
    value,
    onChange,
    loanDetails,
    isApplicationSubmitted,
    sectionName,
    propertyId,
    unitId,
    dynamicConfig,
    mapping,
    currentObjValue
  } = props;

  const valueLabelFormat = (value: number) => {
    return currentObjValue?.prepayPenaltyType || mapping[value];
  };

  // Local buffer, same reasoning as TextFieldComponent — `value` round-trips
  // through LoansContext before the thumb would otherwise move, which reads
  // as a delay dragging/clicking the slider.
  const [localValue, setLocalValue] = useState(value);
  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  return (
    <CustomSlider
      track={false}
      aria-labelledby="non-linear-slider"
      // getAriaValueText={getAriaValueText}
      disabled={
        dynamicConfig?.allowEditAfterSubmit &&
        !(
          field?.isAutoCalculated &&
          field?.isAutoCalculated({
            sizingType: loanDetails?.sizingType,
          })
        )
          ? false
          : isApplicationSubmitted ||
            field?.isAutoCalculated({ sizingType: loanDetails?.sizingType })
      }
      marks={data}
      defaultValue={0}
      max={60}
      step={null}
      valueLabelFormat={valueLabelFormat}
      value={localValue}
      valueLabelDisplay={loanDetails?.sizingType === SizingTypeValue.QUICK_LOAN_SIZING ? "auto" : "off"}
      sx={{ width: "100%", margin: "auto auto" }}
      onChange={(_event: any, newValue: any) => {
        // flushSync — see TextFieldComponent for why this is needed to
        // avoid React 18 batching this with LoansContext's heavier update.
        // (startTransition was also tried, to yield/paint in between, but
        // caused hangs under rapid input — reverted.)
        flushSync(() => setLocalValue(newValue));
        onChange(newValue, "slider", field, sectionName, propertyId, unitId);
      }}
    />
  );
}
